module.exports = __webpack_public_path__ + "img/icon-warm-s.e6ffd88c.png";